<template>
    <a-modal v-model="visible11" title="新增易制爆证件" width="1500px" :footer="null">
        <div>
            <div style="width:100%; display: flex;justify-content: space-between;background: #F4F4F4;height:40px;line-height: 40px;padding:0 20px">
                <span>证件名称</span>
                <span>上传时间</span>
                <span>到期时间</span>
                <span>证件照片</span>
                <span>购买时间</span>
                <span>允许购买商品</span>
            </div>
            <div v-for="(item, index) in data" :key="index">
                <a-radio-group v-model="value" @change="onChange" style="width:100%">
                    <a-radio :value="item.uuid" style="margin:10px 0;background:#e6e6e6;height:40px;line-height: 40px; width:100%;padding:0 10px;">
                        <span style="margin-right: 52px;">易制爆危险化学品合法用途说明</span>
                        <span style="margin-right: 132px;">{{ item.createdAt }}</span>
                        <span style="margin-right: 198px;width: 72px;">{{ item.expirationTime ? item.expirationTime : '--' }}</span>
                        <span style="margin-right: 130px;">
                            <img v-for="(el, i) in item.scanList" @click="downLoadImg(el)" :src="'/api/file/preview/' + el" :key="i" style="width: 20px; height: 20px;margin-right: 5px;" alt="avatar" />
                        </span>
                        <span style="margin-right: 192px;">{{ item.buyTime }}</span>
                        <span v-for="(list, index) in item.allowList" :key="index"
                            ><span>{{ list.name }} &emsp;</span></span
                        >
                    </a-radio>
                </a-radio-group>
            </div>
        </div>
    </a-modal>
</template>
<script>
import ImgUpload from './ImgUpload';
export default {
    components: {
        ImgUpload
    },
    data() {
        return {
            visible11: false,
            data: [],
            value: ''
        };
    },
    created() {
        this.api.getmyPage().then(res => {
            this.data = res.data.content;
            console.log(res.data, '应用证书696969');
        });
    },
    methods: {
        onChange(e) {
            // this.uuid = e.uuid
            console.log(this.value);
            this.visible11 = false;
            this.$emit('child-event', this.value);
        },
        downLoadImg(el) {
            window.open('/api/fileNew/download/' + el, '_blank');
        }
    }
};
</script>

<style scoped>
/deep/.ant-form-item {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgUpload/YizhiBao.vue